"use strict";

var _classCallCheck = require("/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/node_modules/@babel/runtime/helpers/inherits");

var _taggedTemplateLiteral = require("/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  margin: auto;\n  max-width: ", "px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  min-width: ", "px;\n  flex-direction: column;\n  background-color: ", ";\n  min-height: 100vh;\n\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var styled_components_1 = __importDefault(require("styled-components"));

var Content_1 = require("./Content");

var Page = styled_components_1.default.div(_templateObject(), function (_ref) {
  var theme = _ref.theme;
  return theme.grid.minWidth;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.background;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fonts.bodyStyle;
});
var Wrapper = styled_components_1.default.div(_templateObject2(), function (_ref4) {
  var theme = _ref4.theme;
  return theme.grid.breakpoints.lg;
});

var PageWrapper =
/*#__PURE__*/
function (_React$Component) {
  _inherits(PageWrapper, _React$Component);

  function PageWrapper() {
    _classCallCheck(this, PageWrapper);

    return _possibleConstructorReturn(this, _getPrototypeOf(PageWrapper).apply(this, arguments));
  }

  _createClass(PageWrapper, [{
    key: "render",
    value: function render() {
      var children = this.props.children;
      return React.createElement(Page, null, React.createElement(Wrapper, null, React.createElement(Content_1.Content, null, children)));
    }
  }]);

  return PageWrapper;
}(React.Component);

exports.PageWrapper = PageWrapper;